import {Component, input, Input, InputSignal, model, ModelSignal, OnInit} from '@angular/core';
import {PrintInventaireService} from '../../../../core/services/gestion-stock/print-inventaire.service';
import {SearchSupplierWrapper} from '../../../../core/suppliers/wrappers/search-supplier-wrapper';
import {saveAs} from 'file-saver';
import {PrintOptionInventaire} from '../../../../core/models/gestion-stock/print-inventaire.model';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {DxDataGridModule, DxPopupModule} from "devextreme-angular";
import {DxoPagerModule, DxoPagingModule} from "devextreme-angular/ui/nested";
import {HistoriqueInventaireConflitDto} from "../../../../core/dtos/historique-inventaire-conflit-dto";

@Component({
  selector: 'yo-dialog-conflit-inventaire',
  templateUrl: './dialog-conflit-inventaire.component.html',
  imports: [
    DxPopupModule,
    DxDataGridModule,
    DxoPagerModule,
    DxoPagingModule
  ],
  styleUrls: ['./dialog-conflit-inventaire.component.scss']
})
export class DialogConflitInventaireComponent {

  public conflitList: InputSignal<HistoriqueInventaireConflitDto[]> = input<HistoriqueInventaireConflitDto[]>([]);

  public displayDialog: ModelSignal<boolean> = model<boolean>(false);

  typeEnum = [
    {value: null, text: 'Type inconnu'},
    {value: 'COMMANDE_FOURNISSEUR', text: 'Commande fournisseur'},
    {value: 'PLAN_PRODUCTION', text: 'Plan de production'},
  ];

  onClose() {
    this.displayDialog.set(false);
  }

  getConflitTypeLabel(type: string): string {
    let result = this.typeEnum.filter(t => t.value === type);
    return result.length > 0 ? result[0].text : this.typeEnum[0].text;
  }

}
